import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import CryptoJS from "crypto-js";

export default {
name: 'signIn',
components: {
Tab,
TabItem,
XHeader,
XInput,
Group,
CheckIcon,
XButton,
Toast
},
data () {
return {
index: 0,
phoneReg: /^1[3456789]\d{9}$/,  //手机号正则
rememberPsd: true,    //记住密码
togglePassword: 'password', //密码输入框的类型
togglePsdIcon: require('../../assets/images/hidePsd.png'),  //切换显示密码、隐藏密码的icon路径
timerText: '获取验证码',
isDisabled: false,  //获取验证码按钮的 disabled
disabledActive: false,  //获取验证码后倒计时的样式
maskValue: '',  //用户名称双向绑定
maskValue2: '', //新密码双向绑定
maskValue3: '', //确认密码双向绑定
maskValue4: '', //手机号双向绑定
maskValue5: '', //验证码双向绑定
isVouchers:false,
desUtil: {

_key: "F9387E75D65343CA87103DE403D7CDBFB7F0163776164FEC956406DB2DBD401D",

_type: 1,

encrypt: function(message) {
var key = this._key;
var keyHex = CryptoJS.enc.Utf8.parse(key);
var encrypted = CryptoJS.DES.encrypt(message, keyHex, {
mode: CryptoJS.mode.ECB,
padding: CryptoJS.pad.Pkcs7
});
var result = "";
switch (this._type.toString()) {
case "1":

result = encrypted.ciphertext.toString(CryptoJS.enc.Hex);
console.log(result);

break;
}
return result;
}
}
}
},
methods: {
getCodeFun () {   //获取验证码的函数
this.$request.post('/message/verificationCode',{
phone: this.maskValue4.replace(/\ +/g, "")
},).then(data => {
console.log(data)
}).catch(e => {
console.log(e)
})
},
signInFun (data) {
this.$request.post('/user/register',data,).then(data => {
if(data.code == 0){   //注册成功

sessionStorage.setItem('salesmanCode','')

this.$vux.toast.show({
type: 'success',
text: data.msg,
time: 600
})
this.setCookie('_token', data.obj.token, 0.576)





this.getVoucher()
}else{    //否则
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
this.$vux.toast.show({
type: 'cancel',
text: e.msg
})
})
},
setCookie(cname, cvalue, exdays) {



var d = new Date();
d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
var expires = "expires=" + d.toUTCString();
document.cookie = cname + "=" + cvalue + "; " + expires+"; path=/"   
console.log(d)
},
togglePsd () {  //切换显示、隐藏密码
if(this.togglePassword == 'password'){
this.togglePassword = 'text'
this.togglePsdIcon = require('../../assets/images/phone.png')
}else{
this.togglePassword = 'password'
this.togglePsdIcon = require('../../assets/images/hidePsd.png')
}
},
getCode () {  //获取验证码
let phone = this.maskValue4.replace(/\ +/g, "");

if(phone == ''){
this.$vux.toast.show({
type: 'warn',
text: '手机号码为空'
})
return false;
}else{
if(!this.phoneReg.test(phone)){
this.$vux.toast.show({
type: 'warn',
text: '手机号码有误'
})
return false;
}else{
this.getCodeFun()
this.isDisabled = true
this.disabledActive = true
let codeTimer = 60
let timeOutFn = setInterval(() => {
this.timerText = codeTimer-- + 's 后重新获取'
if(codeTimer == -1){
clearInterval(timeOutFn)
this.timerText = '获取验证码'
this.isDisabled = false
this.disabledActive = false
}
}, 1000);
}
}
},
checkPhone () {
let phone = this.maskValue4.replace(/\ +/g, "")
if(phone != '' && !this.phoneReg.test(phone)){
this.$vux.toast.show({
type: 'warn',
text: '手机号码有误'
})
return false;
}else{
if(phone != '')

this.$request.post('/user/getByPhone',{
phone
},).then(data => {
data.code == 0 ?   //未注册过
console.log(data)
:                   //否则
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}).catch(e => {
this.$vux.toast.show({
type: 'cancel',
text: e
})
})
}
},
submit () { //确定提交
let phone = this.maskValue4.replace(/\ +/g, ""),
name = this.maskValue.replace(/\ +/g, ""),
password = this.maskValue2.replace(/\ +/g, ""),
againPsd = this.maskValue3.replace(/\ +/g, ""),
verificationCode = this.maskValue5.replace(/\ +/g, "");

if(name == ''){
this.$vux.toast.show({
type: 'warn',
text: '用户名称为空'
})
return false;
}

if(password == ''){
this.$vux.toast.show({
type: 'warn',
text: '新密码为空'
})
return false;
}

if(againPsd == ''){
this.$vux.toast.show({
type: 'warn',
text: '请确认密码'
})
return false;
}

if(phone == ''){
this.$vux.toast.show({
type: 'warn',
text: '手机号码为空'
})
return false;
}else if(!this.phoneReg.test(phone)){
this.$vux.toast.show({
type: 'warn',
text: '手机号码有误'
})
return false;
}

if(verificationCode == ''){
this.$vux.toast.show({
type: 'warn',
text: '验证码为空'
})
return false;
}

if(password != againPsd){
this.$vux.toast.show({
type: 'warn',
text: '密码不一致'
})
return false;
}

let _password = this.desUtil.encrypt(password);

let datas = {   //注册传的参数
name,
password: _password,
phone,
invitationCode: this.$common.getCookie('_mobileInviteCode'),
verificationCode:verificationCode,
salesmanCode: sessionStorage.getItem('salesmanCode')
}

this.signInFun(datas)




















},
getVoucher(){
this.$request.post('/couponDetail/getNewPeopleCoupon',{

},).then(data => {
if(data.code ==0) {
this.isVouchers = true



}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}

})
},
close(){


if(sessionStorage.getItem('page')=='1'){

this.$router.push({
path: '/'
})
}else{
this.$router.push({
path: '/'
})
}


},
use(){
this.$router.push({
path: '/print'
})
}
},
created () {
console.log(this.$common.getCookie('_mobileInviteCode'))

}
}



// WEBPACK FOOTER //
// ./src/views/signIn/script.js